import { EntityAdapter, EntityState, createEntityAdapter } from "@ngrx/entity";

import { CallState, LoadingState } from "@core/models";

import { ProductContainer } from "@shared/models";

import { sortByName } from "../sort-by-name";



export interface ProductContainersState extends EntityState<ProductContainer> {
  callState: CallState;
}

export const productContainersAdapter: EntityAdapter<ProductContainer> =
  createEntityAdapter<ProductContainer>({
    selectId: (x) => { return `P${x.productCode}|C${x.containerCode}` },
    sortComparer: sortByNameAndActive
  });

export const initialState: ProductContainersState = productContainersAdapter.getInitialState({
  callState: LoadingState.INIT,
});

/*
Sorter
*/
function sortByNameAndActive(a: ProductContainer, b: ProductContainer) {
  if (!a.isActive && b.isActive) { return 1;}
  if (a.isActive && !b.isActive) { return -1;}

  return sortByName(a, b);
}
